module.exports = vendor_c13dca28620aea4aede0;